// One row of api-next's integratorWebhookLog: an outgoing webhook call to an integrator.
// Every value here mirrors what GET /integrator-webhook-logs returns.
export var EIntegratorWebhookLogOutcome;
(function (EIntegratorWebhookLogOutcome) {
    EIntegratorWebhookLogOutcome["Succeeded"] = "SUCCEEDED";
    EIntegratorWebhookLogOutcome["Failed"] = "FAILED";
})(EIntegratorWebhookLogOutcome || (EIntegratorWebhookLogOutcome = {}));
// The types the list shows and filters on: the stored `webhookType`, except that api-next splits
// the stored `entity` into the entity the call was about. In display order.
export var EIntegratorWebhookType;
(function (EIntegratorWebhookType) {
    EIntegratorWebhookType["Application"] = "application";
    EIntegratorWebhookType["Document"] = "document";
    EIntegratorWebhookType["Property"] = "property";
    EIntegratorWebhookType["Contract"] = "contract";
    EIntegratorWebhookType["Contact"] = "contact";
    EIntegratorWebhookType["Payment"] = "payment";
})(EIntegratorWebhookType || (EIntegratorWebhookType = {}));
export var EIntegratorWebhookLogResendStatus;
(function (EIntegratorWebhookLogResendStatus) {
    EIntegratorWebhookLogResendStatus["Ok"] = "OK";
    EIntegratorWebhookLogResendStatus["Failed"] = "FAILED";
    EIntegratorWebhookLogResendStatus["Skipped"] = "SKIPPED";
})(EIntegratorWebhookLogResendStatus || (EIntegratorWebhookLogResendStatus = {}));
// Why a resend was refused or failed. The API answers with a code; the label is ours.
export var EIntegratorWebhookLogResendReason;
(function (EIntegratorWebhookLogResendReason) {
    EIntegratorWebhookLogResendReason["AuthenticationFailed"] = "AUTHENTICATION_FAILED";
    EIntegratorWebhookLogResendReason["BrokerNotLinked"] = "BROKER_NOT_LINKED";
    EIntegratorWebhookLogResendReason["IntegratorNotFound"] = "INTEGRATOR_NOT_FOUND";
    EIntegratorWebhookLogResendReason["NoAuthConfigured"] = "NO_AUTH_CONFIGURED";
    EIntegratorWebhookLogResendReason["NoRequestBody"] = "NO_REQUEST_BODY";
    EIntegratorWebhookLogResendReason["NotFound"] = "NOT_FOUND";
    EIntegratorWebhookLogResendReason["RequestBodyInvalid"] = "REQUEST_BODY_INVALID";
    EIntegratorWebhookLogResendReason["RequestBodyRedacted"] = "REQUEST_BODY_REDACTED";
    EIntegratorWebhookLogResendReason["RequestBodyTruncated"] = "REQUEST_BODY_TRUNCATED";
    EIntegratorWebhookLogResendReason["RequestFailed"] = "REQUEST_FAILED";
    EIntegratorWebhookLogResendReason["TimeBudgetExceeded"] = "TIME_BUDGET_EXCEEDED";
    EIntegratorWebhookLogResendReason["UnsupportedMethod"] = "UNSUPPORTED_METHOD";
    EIntegratorWebhookLogResendReason["UrlNotConfigured"] = "URL_NOT_CONFIGURED";
})(EIntegratorWebhookLogResendReason || (EIntegratorWebhookLogResendReason = {}));
// The columns api-next can order the list by; it refuses any other value.
export var EIntegratorWebhookLogSortBy;
(function (EIntegratorWebhookLogSortBy) {
    EIntegratorWebhookLogSortBy["CreatedAt"] = "createdAt";
    EIntegratorWebhookLogSortBy["DurationMs"] = "durationMs";
    EIntegratorWebhookLogSortBy["Integrator"] = "integrator";
    EIntegratorWebhookLogSortBy["Outcome"] = "outcome";
    EIntegratorWebhookLogSortBy["Owner"] = "owner";
    EIntegratorWebhookLogSortBy["ResponseStatus"] = "responseStatus";
    EIntegratorWebhookLogSortBy["TriggeredBy"] = "triggeredBy";
    EIntegratorWebhookLogSortBy["WebhookType"] = "webhookType";
})(EIntegratorWebhookLogSortBy || (EIntegratorWebhookLogSortBy = {}));
export var EIntegratorWebhookLogSortOrder;
(function (EIntegratorWebhookLogSortOrder) {
    EIntegratorWebhookLogSortOrder["Asc"] = "ASC";
    EIntegratorWebhookLogSortOrder["Desc"] = "DESC";
})(EIntegratorWebhookLogSortOrder || (EIntegratorWebhookLogSortOrder = {}));
